import React from "react";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "@mui/material";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import styles from "./TermsAndConditionsFormGroup.module.scss";
import { checkout_form } from "../../../CheckoutForm/CheckoutForm.constants";

const {
    terms_and_conditions_details: {
        field_names: { agree_to_terms_and_conditions },
    },
} = checkout_form;
const TermsAndConditionsFormGroup = () => {
    const { termsAndConditionsUrl } = useCheckoutBasicDetailsContext();

    const { getValues, setValue } = useFormContext();

    const handleTermsAndConditionsClick = () => {
        window.open(termsAndConditionsUrl, "_blank");
    };

    const handleCheckboxClick = () => {
        const data = getValues() || {};
        const isChecked = data[agree_to_terms_and_conditions] || false;
        setValue(agree_to_terms_and_conditions, !isChecked);
    };

    if (!termsAndConditionsUrl) {
        return <></>;
    }

    return (
        <div className={styles.mainContainer}>
            <Checkbox
                size="small"
                onClick={handleCheckboxClick}
                className={styles.checkboxStyles}
            />
            <div className={styles.textStyles}>
                I have read and agreed to the{" "}
                <span
                    className={styles.termsAndConditionsStyles}
                    onClick={handleTermsAndConditionsClick}
                >
                    Terms and Conditions
                </span>
            </div>
        </div>
    );
};

export default TermsAndConditionsFormGroup;
